import './CancelResult.css';

function CancelResult() {
  const navigateTo = (page) => {
    window.location.hash = page;
  };

  return (
    <div className="cancel-result-page">
      <header className="page-header">
        <h1 className="page-title">解约结果</h1>
      </header>

      <main className="page-content">
        <div className="result-card">
          <div className="result-icon success">✓</div>
          <h2 className="result-title">解约成功</h2>
          <p className="result-desc">您已成功取消自动续费服务</p>
        </div>

        <section className="section">
          <h3 className="section-title">温馨提示</h3>
          <div className="info-list">
            <div className="info-item">
              <span className="info-icon">1</span>
              <span className="info-text">取消后您的会员服务将持续到当前周期结束</span>
            </div>
            <div className="info-item">
              <span className="info-icon">2</span>
              <span className="info-text">到期后不再自动扣款，服务自动终止</span>
            </div>
            <div className="info-item">
              <span className="info-icon">3</span>
              <span className="info-text">如需重新开通服务，可在会员卡页面操作</span>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}

export default CancelResult;
